import { useEffect, useState } from 'react';
import './App.css';
import { loadAllCampaigns } from './QueryCampaign';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import AdCreative from './AdCreative';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import CampaignStatus from './campaigns/CampaignStatus';

function V2Campaigns({ menu }) {
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);

    useEffect(
        () => {
            loadAllCampaigns().then(
                (response) => {
                    setCampaigns(response.data);
                }
            ).catch(
                (error) => {
                    console.log(error);
                }
            )
        },
        [],
    )

    return (
        <div>
            {menu}
            <DataTable
                value={campaigns}
                paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                stripedRows
            >
                <Column
                    key={1}
                    header='Creative'
                    body={
                        (p) =>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                                onClick={
                                    () => navigate(`/campaign?campaign_id=${p.id}`)
                                }
                            >
                                <div style={{ width: '8em', marginRight: '1em' }}>
                                    <AdCreative
                                        creativeURL={p.creative_url}
                                        creativeExt={p.creative_ext}
                                        width='100%'
                                        height='100%'
                                        objectFit='contain'
                                    />
                                </div>
                                <div>
                                    {p.title}
                                </div>
                            </div>
                    }
                />
                <Column
                    key={1}
                    header='Title'
                    field='title'
                    body={
                        (p) =>
                            <div>

                                <div>
                                    <Button
                                        label='View details'
                                        size='small'
                                        outlined
                                        severity='secondary'
                                        onClick={
                                            () => navigate(`/campaign?campaign_id=${p.id}`)
                                        }
                                        style={{ marginTop: '1em' }}
                                    />
                                </div>
                            </div>
                    }
                />
                <Column
                    key={1}
                    header='Status'
                    body={
                        (p) => <CampaignStatus camapign={p} />
                    }
                />
            </DataTable>
        </div>
    );
}

export default V2Campaigns;